import { io } from "socket.io-client";
import api from "./api";

let sharedSocket = null;
const binListeners = new Set();

function ensureSocket() {
  const token = localStorage.getItem("token");
  if (!token) return null;

  if (sharedSocket?.connected) {
    return sharedSocket;
  }

  if (sharedSocket) {
    try {
      sharedSocket.disconnect();
    } catch {
      // ignore
    }
    sharedSocket = null;
  }

  const baseURL = api.defaults.baseURL || "";
  const origin = baseURL.replace(/\/?api\/?$/i, "") || baseURL;

  sharedSocket = io(origin, {
    auth: { token },
    transports: ["websocket", "polling"],
  });

  sharedSocket.on("bin:updated", (payload) => {
    const bin = payload?.bin ?? null;
    binListeners.forEach((fn) => {
      try {
        fn(bin);
      } catch (e) {
        console.error("bin listener error:", e);
      }
    });
  });

  return sharedSocket;
}

/**
 * Subscribe to server-pushed bin updates (one shared connection per tab).
 * @param {(bin: object | null) => void} onBin
 * @returns {() => void} cleanup
 */
export function subscribeBinUpdates(onBin) {
  const token = localStorage.getItem("token");
  if (!token) return () => {};

  ensureSocket();
  binListeners.add(onBin);

  return () => {
    binListeners.delete(onBin);
    if (binListeners.size === 0 && sharedSocket) {
      sharedSocket.off("bin:updated");
      sharedSocket.disconnect();
      sharedSocket = null;
    }
  };
}
